export const getTitle = (message = '', varArray) => {
  const re = new RegExp(/\{.*?\}/g)
  let index = 0
  return message.replace(re, matched => {
    const value = varArray[index] || ''
    index++
    return value
  })
}
